import seatConfirmation from '../../media/seat-confirmation.png';
import seatLogo from '../../media/seat-logo.svg';

const CAR_MODEL_ID = 72; // ID différent pour Seat
// Configuration spécifique Seat
export const seatConfig = {
  // Configuration de l'application
  app: {
    carModelId: CAR_MODEL_ID,
    maxCommentLength: 200,
    sessionStorageKey: 'rdv_live',
    maxWorkingDaysAhead: 10,
  },

  // API Endpoints
  api: {
    calendar: `/calendar_for_business_center/${CAR_MODEL_ID}`,
    saveAppointment: 'save_appointment_for_business_center/',
  },

  // Url externes
  urlExternes: {
    rgpd: 'https://www.seat.fr/entreprise/mentions-legales',
  },

  // Messages
  messages: {
    loading: 'Chargement des disponibilités...',
    loadingAvailabilities: 'Chargement des disponibilités...',
    errorLoading: 'Erreur lors du chargement des données',
    errorAppointment:
      'Nous rencontrons actuellement un problème lors de la prise de votre rendez-vous. Nous vous prions de bien vouloir réessayer ultérieurement. Nous nous excusons pour ce désagrément.',
    errorTicketNotFound: 'Rendez-vous créé, mais ticket introuvable',
    errorDataLoading: 'Impossible de charger les données.',
    errorZendeskIdMissing:
      "Impossible d'enregistrer votre rendez-vous,  merci de prendre contact avec votre conseiller automobile.",
    errorCommentInvalid:
      'Erreur : Le commentaire contient des caractères non autorisés. Veuillez modifier votre message.',
    confirmationTitle: 'Merci de votre confiance !',
    confirmationSubtitle: 'Votre rendez-vous est confirmé',
    returnToMenu: 'Retour au menu',
    returnToMainMenu: 'Revenir au menu principal',
    retry: 'Réessayer',
    dateLabel: '',
    mainTitle: 'Réservez votre rendez-vous téléphonique avec un conseiller connecté',
    timeSelectionTitle: 'Sélectionnez un créneau horaire',
    commentPlaceholder:
      'Ajoutez un commentaire à transmettre à votre conseiller',
    confirmButton: 'Confirmer ma réservation',
    breadcrumbDate: 'Date',
    breadcrumbSlot: 'Créneau',
    breadcrumbSeparator: ' > ',
    dateSimulator: 'Simulateur de date (DEV)',
    resetToToday: "Remettre à aujourd'hui",
    testConfirmation: 'Tester la confirmation',
    rgpdText:
      'Pour en savoir plus sur la gestion de vos données personnelles et pour connaître vos droits et les exercer, reportez-vous à la ',
    rgpdLinkText: 'Charte des Données Personnelles',
  },

  // Images
  images: {
    logo: seatLogo,
    confirmation: seatConfirmation, // Temporaire - à remplacer par l'image Seat
  },

  // Configuration du design
  design: {
    name: 'Seat',
    logo: seatLogo,
    fontFamily: 'Seat', // Temporaire - à remplacer par la police Seat

    // Poids de la police par type de texte
    fontWeight: {
      title: '400', // Titre principal (bold)
      subtitle: '600', // Sous-titre (semi-bold)
      body: '400', // Texte normal
      button: '500', // Boutons (medium)
      label: '500', // Labels (medium)
      caption: '400', // Texte secondaire
      calendarDay: '500', // Jours du calendrier (medium)
      timeSlot: '500', // Créneaux horaires (medium)
      timeSlotSelected: '900', // Créneaux horaires sélectionnés (black)
      calendarDate: '600', // Date du calendrier (semi-bold)
    },

    // Taille de la police par type de texte
    fontSize: {
      title: '28px', // Titre principal
      subtitle: '18px', // Sous-titre
      body: '16px', // Texte normal
      button: '16px', // Boutons
      label: '14px', // Labels
      caption: '12px', // Texte secondaire
      calendarDay: '16px', // Jours du calendrier
      timeSlot: '16px', // Créneaux horaires
    },

    // Couleurs principales
    primaryColor: '#000000', // Noir Seat
    secondaryColor: '#ffffff', // Blanc
    accentColor: '#f5d11f', // Jaune Seat

    // Couleurs de texte
    textPrimary: '#000000', // Texte principal
    textSecondary: '#FFFFFF', // Texte secondaire
    textRgpdColor: '#707070', // Texte RGPD
    textDisabled: '#F9F8F6', // Texte désactivé
    textPlaceholder: '#b3b3b3', // Texte placeholder

    // Couleurs de fond
    backgroundPrimary: '#ffffff', // Fond principal
    backgroundSecondary: '#f5f5f5', // Fond secondaire
    backgroundHover: '#f0f0f0', // Fond au survol
    backgroundSelected: '#000000', // Fond sélectionné

    // Couleurs des bordures
    borderPrimary: 'none', // Bordure principale
    borderSecondary: '#cccccc', // Bordure secondaire
    borderFocus: '#000000', // Bordure focus

    // Couleurs d'état
    successColor: '#000000', // Vert succès
    errorColor: '#dc3545', // Rouge erreur
    warningColor: '#ffc107', // Jaune avertissement
    infoColor: '#17a2b8', // Bleu info

    // Couleurs des boutons
    buttonPrimary: '#F90942', // Bouton principal
    buttonPrimaryHover: '#F90942', // Bouton principal survol
    buttonSecondary: '#ffffff', // Bouton secondaire
    buttonSecondaryHover: '#f5f5f5', // Bouton secondaire survol
    buttonDisabled: '#cccccc', // Bouton désactivé

    // Rayon des bordures des boutons
    buttonBorderRadius: '26px', // Rayon des bordures des boutons
    calendarDayBorderRadius: '0px', // Rayon des bordures des jours du calendrier
    timeSlotBorderRadius: '0px', // Rayon des bordures des créneaux horaires

    // Couleurs du calendrier
    calendarHeader: '#666666', // En-tête calendrier
    calendarDay: '#000000', // Jour calendrier
    calendarDayHover:
      'linear-gradient(270deg, #F90942 0%, #BF0A37 50%, #D44364 100%)', // Jour calendrier survol
    calendarDaySelected:
      'linear-gradient(270deg, #F90942 0%, #BF0A37 50%, #D44364 100%)', // Jour sélectionné
    calendarDayDisabled: '#F9F8F6', // Jour désactivé
    calendarDayHoverText: '#ffffff', // Couleur du texte en hover
    calendarDaySelectedText: '#ffffff', // Couleur du texte sélectionné

    // Couleurs des créneaux horaires
    timeSlot: '#ffffff', // Créneau horaire
    timeSlotHover:
      'linear-gradient(270deg, #F90942 0%, #BF0A37 50%, #D44364 100%)', // Créneau survol
    timeSlotSelected:
      'linear-gradient(270deg, #F90942 0%, #BF0A37 50%, #D44364 100%)', // Créneau sélectionné
    timeSlotDisabled: '#F9F8F6', // Créneau désactivé
    timeSlotTextDisabled: '#838383', // Texte créneau désactivé
    timeSlotHoverText: '#ffffff', // Couleur du texte en hover
    timeSlotSelectedText: '#ffffff', // Couleur du texte sélectionné
  },

  // Configuration des slugs
  slugs: {
    seatFiscale: 'seat-bc',
  },

  // Configuration des marques RDV
  marqueRdv: {
    bc: 'marquerdv_seatbc',
  },

  // Données de test
  testData: {
    confirmationDate: '18 / 09 / 2025',
    confirmationTime: '12 : 30',
  },
};
